export enum FieldControl {
    DROPDOWN = 'Dropdown',
    DROPDOWN_WITH_IMG = 'DropdownWithImg',
	FLAT_SELECT = 'FlatSelect',
	FLAT_SELECT_WITH_IMG = 'FlatSelectWithImg',
	FLAT_SELECT_IMG_AND_TEXT_ONLY = 'FlatSelectImgAndTextOnly',
	FLAT_SELECT_WITH_HOVER_IMG = 'FlatSelectWithHoverImg',
	FLAT_SELECT_IMG_ONLY = 'FlatSelectImgOnly',
    FLAT_IMAGE_GALLERY = 'FlatImageGallery',
	POPUP_FLAT_SELECT_IMG_ONLY = 'PopupFlatSelectImgOnly',
    RADIO_BUTTON = 'RadioButton',
    DATE_PICKER = 'DatePicker',
    DATE_INPUTS = 'DateInputs',
    DATE_INPUT_INLINE_TITLE = 'DateInputInlineTitle',
    TEXTBOX = 'Textbox',
    NUMBER = 'Number',
    CURRENCY = 'Currency',
    CURRENCY_ILS = 'CurrencyILS',
    CURRENCY_USD = 'CurrencyUSD',
    JAMBO_FLAT_SELECT = 'JamboFlatSelect',
    MAIN_SEPARATOR = 'MainSeparator',
    SUB_SEPARATOR = 'SubSeparator',
    SIGNATURE = 'Signature',
    FILE_UPLOAD = 'FileUpload',
    GRID = 'Grid',
    BARCODE = 'BarCode',
    FLAT_SELECT_IMAGE_ON_CLICK = 'FlatSelectImageOnClick',
    MULTI_SELECT_GROUPS = 'MultiSelectGroups',
    STAR_RATING = 'StarRating',
    CAPTCHA = 'Captcha',
    NUMBER_RATING = 'NumberRating',
    SELECT_SEARCH = 'SelectSearch',
    MULTI_SELECT_SEARCH = 'MultiSelectSearch',
    PERCENTAGE = 'Percentage',
	NGX_COMPONENT = 'NgxComponent',
	HIDDEN = 'hidden',
    CHECKBOX = 'Checkbox',
    SLIDE_TOGGLE = 'SlideToggle',
    TEXTAREA = 'Textarea',
    CONFIRMATION_FIELD = 'ConfirmationField',
    CARD_VALIDITY = 'CardValidity',
    PHONE_WITH_PREFIX = 'PhoneWithPrefix',
    MOBILE_WITH_PREFIX = 'MobileWithPrefix',
    USERS_AUTOCOMPLETE = 'UsersAutocomplete',
    AUTOCOMPLETE = 'Autocomplete',
    LOOK_UP_DETAIL = 'LookUpDetail',
    LOOK_UP = 'LookUp',
    USER_LOOK_UP = 'UserLookUp',
    USER_LOOK_UP_DETAIL = 'UserLookUpDetail',
    EDITOR = 'Editor',
}
